export default __webpack_public_path__ + "static/media/banner-buddyup-comp.6705cb21.png";